var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptiveSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.0976562C8.22391 0.0976563 9.87721 0.782475 11.0962 2.00146C12.3152 3.22045 13 4.87375 13 6.59766C13 8.20766 12.41 9.68766 11.44 10.8277L11.71 11.0977H12.5L17.5 16.0977L16 17.5977L11 12.5977V11.8077L10.73 11.5377C9.59 12.5077 8.11 13.0977 6.5 13.0977C4.77609 13.0977 3.12279 12.4128 1.90381 11.1939C0.684819 9.97486 0 8.32156 0 6.59766C0 4.87375 0.684819 3.22045 1.90381 2.00146C3.12279 0.782475 4.77609 0.0976563 6.5 0.0976562ZM6.5 2.09766C4 2.09766 2 4.09766 2 6.59766C2 9.09766 4 11.0977 6.5 11.0977C9 11.0977 11 9.09766 11 6.59766C11 4.09766 9 2.09766 6.5 2.09766Z",
    fill: "#77787B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptiveSearchIcon);
export default __webpack_public_path__ + "static/media/adaptive-search-icon.435a53c1cf95a94c0571699dd34061a4.svg";
export { ForwardRef as ReactComponent };